import { ButterProductsArrRu } from "./ButterProducts/ButterProductsArrRu";
import { CraftProductsArrRu } from "./CraftProductsArr/CraftProductsArrRu";
import { FermentedMilkProductsArrRu } from "./FermentedMilkProductsArr/FermentedMilkProductsArrRu";
import { MilkProductsArrRu } from "./MilkProducts/MilkProductsArrRu";

export const ProductPagesRu = [
   ...MilkProductsArrRu,
   ...ButterProductsArrRu,
   ...FermentedMilkProductsArrRu,
   ...CraftProductsArrRu,
]